import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IconButton, Link, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  getPartnerFile,
  deletePartnerFile,
  getPartnerByID,
} from "../../API/endpoints/Partner";
import DocumentItem from "../components/documentItem/DocumentItem";

interface Document {
  id: string;
  file_name: string;
  path: string;
  description: string;
  services: any;
}

export default function PartnerManageFiles(props: any) {
  const { setIsOpen, isOpen = false } = props;
  const [documents, setDocuments] = useState<Document[]>([]);
  console.log(isOpen, "isOpen");
  const handleClickOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const deleteDocumentHandler = (id: any) => {
    (async () => {
      try {
        const response = await deletePartnerFile(id);
        console.log(response, "Delete");
        fetchPartnerFiles();
      } catch (error) {}
    })();
  };

  const fetchPartnerFiles = () => {
    (async () => {
      try {
        const response = await getPartnerFile(isOpen);
        setDocuments(response.data);

        const partnerData = await getPartnerByID(isOpen);
        const staticDocs = [
          {
            file_name: "Company Overview",
            path: partnerData?.data?.company_overview,
            description: "Uploaded at onboarding",
            id: "static-company-overview",
          },
          {
            file_name: "Client Portfolio",
            path: partnerData?.data?.client_portfolio,
            description: "Uploaded at onboarding",
            id: "static-client-portfolio",
          },
          {
            file_name: "Draft Agreement",
            path: partnerData?.data?.draft_agreements,
            description: "Uploaded at onboarding",
            id: "static-draft-agreement",
          },
        ].filter((doc) => !!doc.path); // filter out undefined/null URLs

        // Combine dynamic and static documents
        setDocuments([...staticDocs, ...(response?.data || [])]);
      } catch (error) {}
    })();
  };

  useEffect(() => {
    fetchPartnerFiles();
  }, [isOpen]);

  return (
    <React.Fragment>
      <Dialog
        className="modal_867"
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Manage Files"}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Document Name</TableCell>
                  <TableCell align="left">Description</TableCell>
                  <TableCell align="left">File</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {documents &&
                  documents.map((row) => (
                    <TableRow
                      key={row?.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ width: "25%" }}
                      >
                        {row?.file_name}
                      </TableCell>
                      <TableCell sx={{ width: "50%" }} align="left">
                        {row?.description || "NA"}
                      </TableCell>
                      <TableCell align="right" sx={{ width: "25%" }}>
                        <div
                          style={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                          }}
                        >
                          <DocumentItem name={row.file_name} path={row?.path} />
                        </div>
                      </TableCell>
                      <TableCell align="right" sx={{ width: "10%" }}>
                        <IconButton
                          onClick={() => deleteDocumentHandler(row?.id)}
                        >
                          <img
                            className="mr6px"
                            src="../svgs/Deletelg.svg"
                            alt="delete"
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>cancel</Button>
          <Button
            className="btn btn-primary white"
            onClick={handleClose}
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
